import { render, staticRenderFns } from "./ReferenceItem.vue?vue&type=template&id=a483091c&scoped=true&lang=pug&"
import script from "./ReferenceItem.vue?vue&type=script&lang=ts&"
export * from "./ReferenceItem.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceItem.vue?vue&type=style&index=0&id=a483091c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a483091c",
  null
  
)

component.options.__file = "ReferenceItem.vue"
export default component.exports